export default __webpack_public_path__ + "static/media/textSortIcon.a1dbedb8.svg";